import {useMemo} from 'react';
import {TrendItem, Trends} from '../components/chart/types';
import {Datapoint} from '@epic-visualizations/charts';

export interface UseChartTrends {
    data: Datapoint[];
    xAxis: string;
    fractionDigits?: number;
    multiplier?: number;
}

const useChartTrends = ({
    data,
    xAxis,
    fractionDigits = 0,
    multiplier = 1
}: UseChartTrends): Trends => {
    let previousItem: Datapoint = {};

    return useMemo(
        () =>
            data.reduce((trends: Trends, item: Datapoint) => {
                const key = item[xAxis].toString();

                trends[key] = Object.entries(item).reduce(
                    (acc: TrendItem, [key, value]: [string, number]) => {
                        if (key === xAxis) {
                            return acc;
                        }

                        const previousValue = previousItem[key] as number;
                        const difference = previousValue ? value - previousValue : 0;
                        const fractions = 10 ** fractionDigits;

                        return {
                            ...acc,
                            [key]:
                                (multiplier *
                                    Math.round(
                                        (previousValue ? (difference / previousValue) * 100 : 0) *
                                            fractions
                                    )) /
                                fractions
                        };
                    },
                    {}
                );

                previousItem = item;

                return trends;
            }, {}),
        [data]
    );
};

export default useChartTrends;
